/* global $ */
import React, { Component } from 'react';
import { config } from './config.js';
import {  Redirect} from 'react-router-dom'

class CustomerLogin extends Component {

    componentWillMount(){
        var portalName = new URLSearchParams(this.props.location.search).get('id');

        if (portalName){
          this.setState({error: false});
          window.location = config.sso_authorization_url+'?client_id='+config.sso_client_id+'&redirect_uri='+config.sso_redirect_uri+'&response_type=token&scope=all&state='+portalName;
        } else {
            this.setState({error: true});
        }
    }

    render() {
        var styles1 = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            mozTransform: 'translateX(-50%) translateY(-50%)',
            webkitTransform: 'translateX(-50%) translateY(-50%)',
            transform: 'translateX(-50%) translateY(-50%)',
        };

        if (this.state.error) {
            return (
              <div style={styles1}>
                <h2>Portal Name is not provided</h2>
              </div>
            );
          }
    }
}
export default CustomerLogin;



// WEBPACK FOOTER //
// ./src/CustomerLogin.jsx